import { AlertsWebComponent } from './component/AlertsWebComponent';
import { WEB_COMPONENT_ALERTS } from '../webcomponents.constants';

export { AlertsWebComponent };

window.customElements.define(WEB_COMPONENT_ALERTS, AlertsWebComponent);
